import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import star from "../../../imgs/star.svg";
import axios from "axios";
import moment from "moment/moment";
import { useLocation } from "react-router-dom";

const ProfileDiv = ({ data, refetch, setRefetch, check }) => {
  const priorityPensioner = useSelector((state) => state.priorityPensioner);
  const penVerStatus = useSelector((state) => state.penVerStatus);
  const penVerQueue = useSelector((state) => state.penVerQueue);
  const veriSelectedPensioner = useSelector(
    (state) => state.veriSelectedPensioner
  );
  console.log("veriSelectedPensioner", veriSelectedPensioner);
  const distributionCenter = useSelector((state) => state.distributionCenter);
  console.log(distributionCenter);
  const dataUser = useSelector((state) => state.dataUser);
  const dispatch = useDispatch();
  const [link, setLink] = useState(false);
  const [linked, setLinked] = useState(true);
  const [queue, setQueue] = useState(false);
  const [err, setErr] = useState("");
  const [showErr, setShowErr] = useState(false);
  const [distrData, setDistriData] = useState("");
  useEffect(() => {
    if (priorityPensioner) {
      setLinked(true);
    }
  }, [priorityPensioner]);

  //Get Distribution Data
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/v1/distribution-info?pensionerUserId=${veriSelectedPensioner?.id}`,
        {
          headers: {
            Authorization: `Bearer ${dataUser?.data?.tokens?.access?.token}`,
          },
        }
      )
      .then((data) => {
        setLinked(true);
        setDistriData(data?.data);
      })
      .catch((err) => {
        if (err?.response?.data?.message === "pensionerInfo not found") {
          setErr(err?.response?.data?.message);
          setShowErr(true);
        }
        if (err?.response?.data?.message === "distributionInfo not found") {
          setLinked(false);
        }
        console.log("errr", err);
      });
  }, [refetch]);

  console.log("data", data, check);
  //Linked Center
  const LinkedCenter = () => {
    setLink(false);
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/v1/distribution-info?pensionerUserId=${veriSelectedPensioner?.id}`,
        {
          distributioncoverageId: `${distributionCenter?.id}`,
          consumerInfo: {
            ip: "d",
            location: "d",
          },
        },
        {
          headers: {
            Authorization: `Bearer ${dataUser?.data?.tokens?.access?.token}`,
          },
        }
      )
      .then(() => {
        setRefetch(!refetch);
        dispatch({ type: "RESET" });
      })
      .catch((err) => {
        setErr(err.response.data.message);
        setShowErr(true);
      });
  };

  const AddToQueue = () => {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/v1/verification-queue/add`,
        {
          userId: veriSelectedPensioner?.id,
        },
        {
          headers: {
            Authorization: `Bearer ${dataUser?.data?.tokens?.access?.token}`,
          },
        }
      )
      .then((data) => {
        console.log("data", data);
        dispatch({
          type: "PEN_VER_QUEUE",
          num: data?.data,
        });
      })
      .catch((err) => {
        setErr(err?.response?.data.message);
        setShowErr(true);
      });
  };
  const calculateTime = (createdAt) => {
    const now = moment();
    const duration = moment.duration(now.diff(moment(createdAt)));

    // Format the output in a compact form
    let compactTimeDifference = "";

    if (duration.days() > 0) {
      compactTimeDifference += `${duration.days()}d `;
    }
    if (duration.hours() > 0) {
      compactTimeDifference += `${duration.hours()}h `;
    }
    if (duration.minutes() > 0) {
      compactTimeDifference += `${duration.minutes()}m `;
    }

    // Add seconds if it's less than a minute ago
    if (!compactTimeDifference && duration.seconds() > 0) {
      compactTimeDifference += `${duration.seconds()}s `;
    }

    // compactTimeDifference += "ago";
    return compactTimeDifference;
  };
  const Div = ({ title, content }) => {
    return (
      <div className="flex flex-row gap-1 justify-between">
        <div className="text-md font-medium leading-6 text-gray-600">
          {title}
        </div>
        <div className={`text-md leading-6 font-semibold rounded-md`}>
          {content}
        </div>
      </div>
    );
  };

  return (
    <div className="w-full">
      <div className="flex md:gap-5 gap-2 w-full md:flex-row flex-col relative">
        <div className="md:w-[30%] bg-[#F5F5F5] rounded-md p-4 pl-1 pr-1 relative">
          <header className="px-2 py-4 flex gap-2 items-center flex-col text-center">
            <div className="w-full flex items-center gap-2">
              <img
                src={star}
                alt=""
                className={`${
                  priorityPensioner
                    ? "absolute w-6 h-6 top-4 right-4"
                    : "hidden"
                }`}
              />
              <img
                className={`${"inline-flex object-cover border-4 border-primary rounded-full  bg-primary text-indigo-600 h-20 w-20"}`}
                src={
                  data?.person?.image !== null
                    ? data?.person?.image
                    : "data:image/png;base64,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"
                }
                alt=""
              />
              <div className="h-full flex flex-col ml-2 text-left gap-1">
                <h2 className="text-sm text-primary capitalize font-bold">
                  {data?.person?.firstName
                    ? data.person.firstName + " "
                    : "-----"}
                  {data?.person?.middleName ? data.person.middleName + " " : ""}
                  {data?.person?.lastName ? data.person.lastName : "-----"}
                </h2>
                <h2 className="text-sm">
                  GID :{" "}
                  <span className="font-semibold">
                    {" "}
                    {check === "prior"
                      ? data?.gid
                      : data?.user?.gid !== null
                      ? data?.user?.gid
                      : "-----"}
                  </span>
                </h2>
                <h2 className="text-sm">
                  DOB :{" "}
                  <span className="font-semibold">
                    {data?.person?.dateOfBirth !== null
                      ? moment(data?.person?.dateOfBirth).format("MM/DD/YYYY")
                      : "------"}
                  </span>
                </h2>
              </div>
            </div>
          </header>
        </div>
        <div className="md:w-3/4 w-full bg-[#F5F5F5] md:pl-5  md:pr-5  p-4 rounded-md">
          <div className="w-full  gap-2 flex md:flex-row flex-col  h-full">
            <div className="md:w-[55%] w-full flex flex-col gap-1">
              <Div
                title="Program :"
                content={
                  data?.pensionPrograms?.length > 0
                    ? data?.pensionPrograms?.[0]?.name ===
                      "senior-citizen-Pension"
                      ? "Senior Citizen Pension"
                      : data?.pensionPrograms?.[0]?.name
                    : "Senior Citizen Pension"
                }
              />

              <Div
                title="Registered on :"
                content={
                  check === "prior"
                    ? data?.createdAt !== null
                      ? moment(data?.createdAt).format("MM/DD/YYYY hh:mm A")
                      : "-----"
                    : data?.user?.createdAt !== null
                    ? moment(data?.user?.createdAt).format("MM/DD/YYYY hh:mm A")
                    : "-----"
                }
              />

              {data?.pensionBooks?.length > 0 && (
                <Div
                  title="Booklet# :"
                  content={`${data?.pensionBooks?.[0]?.bookletNo + " "}(${
                    data?.pensionBooks?.[0]?.year
                  })`}
                />
              )}

              {!linked ? (
                <div className="flex flex-row justify-between">
                  <div className="text-md font-medium leading-6 text-gray-600">
                    Distribution Center :
                  </div>
                  <div className={`text-md leading-6 font-semibold rounded-md`}>
                    <button
                      className="text-white bg-primary px-3 rounded-md cursor-pointer"
                      onClick={() => {
                        setLink(true);
                      }}
                    >
                      Link Center
                    </button>
                  </div>
                </div>
              ) : (
                <Div
                  title="Distribution Centre :"
                  content={
                    distrData
                      ? distrData?.distributioncoverage?.coverage +
                        " " +
                        distrData?.distributioncoverage?.distributioncenter?.distributionlocation
                          ?.distributionregion?.regionNo
                      : "------"
                  }
                />
              )}
            </div>
            <div className="md:w-[45%] w-full flex flex-col gap-1">
              <div className="w-full flex items-center md:justify-end mt-1">
                {penVerQueue.length === 0 &&
                  penVerStatus !== "Pension Book Distributed" && (
                    <button
                      onClick={() => {
                        setQueue(true);
                        AddToQueue();
                      }}
                      className="cursor-pointer md:w-[40%] w-full p-1 pl-2 pr-2  rounded-md text-center text-white font-semibold bg-primary "
                    >
                      Add to Queue
                    </button>
                  )}
                {(penVerQueue.length !== 0 ||
                  penVerStatus === "Pension Book Distributed") && (
                  <div className="flex items-center flex-col gap-2 md:w-[90%] w-full">
                    <div className="w-full rounded-md text-center text-white font-semibold">
                      <div
                        className={`border-none ${
                          penVerStatus === "Verification Pending"
                            ? "bg-yellow-400"
                            : penVerStatus === "Verification Rejected"
                            ? "bg-[#EF4D5C]"
                            : "bg-primary"
                        } inline-block whitespace-nowrap w-full p-1 px-5 rounded-xl flex items-center justify-center text-white focus:border-none cursor-pointer capitalize`}
                      >
                        {penVerStatus}
                      </div>
                    </div>
                    {penVerStatus !== "Pension Book Distributed" && (
                      <div className="w-full flex items-center justify-between">
                        <h2 className="text-gray-400 font-semibold ">
                          Ticket #:
                        </h2>
                        <p className="font-semibold">{penVerQueue.token}</p>
                      </div>
                    )}
                    {penVerStatus !== "Pension Book Distributed" && (
                      <div className="w-full flex items-center justify-between">
                        <h2 className="text-gray-400 font-semibold ">
                          Waiting time:
                        </h2>
                        <p className="font-semibold">
                          {calculateTime(penVerQueue?.createdAt)}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Link to Distribution center */}
      <div
        className={`${
          link ? "" : "hidden"
        } fixed top-0 left-0 w-screen h-screen z-50 flex justify-center items-center bg-black bg-opacity-50`}
      >
        <div className="relative rounded-xl w-[23rem] pb-6 pt-4 flex items-center p-5 bg-white flex-col relative">
          <p className="text-center w-[90%] text-[#757575] mt-3 mb-6 font-semibold">
            Would you like to link this pensioner with the{" "}
            {distributionCenter?.coverage}{" "}
            {
              distributionCenter?.distributioncenter?.distributionlocation
                ?.distributionregion?.regionNo
            }{" "}
            Distribution Center?
          </p>

          <div className=" w-[80%] flex items-center justify-between">
            <button
              type="button"
              className="cursor-pointer text-center flex items-center justify-center rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-primary w-[48%]"
              onClick={() => {
                // setLinked(false);
                // setLink(false);
                LinkedCenter();
              }}
            >
              Yes
            </button>
            <button
              onClick={() => {
                setLink(false);
              }}
              type="button"
              className="cursor-pointer rounded-xl flex items-center justify-center text-center pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-red-600 w-[48%]"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDiv;
